<template>
    <modal
        name="modal-notifications-settings"
        class="modal--translation modal--hide-on-loading modal-notifications-settings"
        v-cloak height="auto"
        :scrollable="true"
        :adaptive="true"
        :pivot-y="0.25"
    >

        <form ref="form">

            <div class="modal-header">
                <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>

                <h5 class="modal-title mb-0">{{trans.title}}</h5>
            </div>

            <div class="modal-body" :class="{'loading': loading }">

                <div v-for="(setting,index) in form" class="setting-item" :key="'form-' + index">
                    <h6>{{ getTitle(setting) }}</h6>

                    <div class="setting-item-inner">
                        <div class="input-group mb-3 mr-3">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <input type="checkbox" :id="'notificationSettingsIsActive_'+index" v-model="setting.is_active" :disabled="loading ? true : false">
                                    <label class="form-check-label input-label-is-active" :for="'notificationSettingsIsActive_'+index"></label>
                                </div>
                            </div>
                        </div>

                        <div class="input-group mb-3">
                            <input type="text" class="form-control d-inline-block input-interval-length" maxlength="3" v-model="setting.interval_length" :disabled="loading ? true : false">

                            <div class="input-group-append">
                              <span class="input-group-text">{{ trans.days_before }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-if="dynamicFields.length">
                    <hr>
                    <h5>{{ trans.dynamic_fields_title }}</h5>

                    <div v-for="(dynamicField, index) in dynamicFields" :key="'dynamic-' + index" class="setting-item">
                        <h6>{{ dynamicField.name }}</h6>

                        <div class="setting-item-inner">
                            <div class="input-group mb-3 mr-3">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <input type="checkbox" :id="'dynamicFieldActive_'+index" v-model="dynamicField.notifiable" :disabled="loading ? true : false">
                                        <label class="form-check-label input-label-is-active" :for="'dynamicFieldActive_'+index"></label>
                                    </div>
                                </div>
                            </div>

                            <div class="input-group mb-3">
                                <input type="text" class="form-control d-inline-block input-interval-length" maxlength="3" v-model="dynamicField.notifiable_days" :disabled="loading ? true : false">
                                <div class="input-group-append">
                                <span class="input-group-text">{{ trans.days_before }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>
            </div>

            <div class="modal-footer text-center justify-content-center">
                <b-button type="button" variant="primary" @click="submitForm()" :class="{'loading disabled': loading }"><i class="fa fa-save"></i> {{ trans.save }}</b-button>
            </div>

        </form>

    </modal>
</template>


<script>
    export default {
        props: {
            'trans': {
                type: Object
            },
            'transTypes': {
                type: Object
            },
            'settings': {
                type: Array
            },
            'dynamicFieldsNotifications': {
                type: Array
            },
            'currentRestaurantId': {
                type: Number
            }

        },

        data: function() {
            return {
                form: this.settings,
                dynamicFields: this.dynamicFieldsNotifications,
                loading: false
            };
        },

        methods: {
            getTitle(item)
            {
                return (typeof this.transTypes[item.type] != "undefined" ? this.transTypes[item.type].title : item.type.replace("App\\Notifications\\",""));
            },

            submitForm(evt)
            {
                this.loading = true;

                axios.post("/dashboard/notification-settings/save", { restaurant: this.currentRestaurantId, settings: this.form, dynamicFields: this.dynamicFields }).then((response) => {
                    this.$notify({ type:  (response.data.state ? 'success' : 'error'),
                                   title: (response.data.state ? this.trans.save_title_ok : this.trans.save_title_err),
                                   text:  (response.data.state ? this.trans.save_message_ok : response.data)
                                });
                    this.loading = false;
                    this.closeModal();
                }, (error) => {
                    this.$notify({ type: 'error', title: this.trans.save_title_err, text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                    this.loading = false;
                    this.closeModal();
                });
            },

            closeModal()
            {
                this.$modal.hide('modal-notifications-settings');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/dashboard/modals/NotificationsSettings.vue